import axios from "axios";

const backendUrl = process.env.NODE_ENV === "production" ? "" : (process.env.REACT_APP_BACKEND_URL || "");
export const api = axios.create({ baseURL: backendUrl ? `${backendUrl}/api` : "/api", withCredentials: true });

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace(/^Value error, /, "");
  return fallback;
};
